<template>
  <div class="result-container">
    <div v-if="!loading">
      <div class="result">
        <div class="back-container" @click="back">
          <span class="back-img"></span>
          <span>返回</span>
        </div>
        <div
          class="status-img"
          :class="{ 'error-img': isError, 'success-img': !isError }"
        ></div>
        <div class="status-desc">{{ desc }}</div>
        <div class="status-sub-desc">{{ subDesc }}</div>
        <j-button class="btn-back" @click="back" text="返回首页"></j-button>
        <div class="error-desc" v-if="isError">
          {{ error }}
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading">
      正在认证...
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import JButton from '@/components/JButton.vue';
import environment from '@/environment.js';

export default {
  data() {
    return {
      error: '',
      loading: true,
    };
  },
  mounted() {
    const phone = localStorage.getItem('jverificationDemo_phone');
    const token = localStorage.getItem('jverificationDemo_token');
    const verificationUrl = environment.VUE_APP_VERIFICATION_URL;
    axios.post(verificationUrl, {
      token,
      phone,
    }).then((data) => {
      console.log(data);
      this.loading = false;
    }).catch((error) => {
      const { data } = error.response || { data: { content: '-' } };
      this.error = data.content;
      this.loading = false;
    });
  },
  components: {
    JButton,
  },
  computed: {
    isError() {
      return this.error !== '';
    },
    desc() {
      let data = '';
      if (this.error === '') {
        data = '认证成功！';
      } else {
        data = '认证失败！';
      }
      return data;
    },
    subDesc() {
      let data = '';
      if (this.error === '') {
        data = `手机号码为：${localStorage.getItem('jverificationDemo_phone')}`;
      } else {
        data = '可用短信验证码补充';
      }
      return data;
    },
  },
  methods: {
    back() {
      this.$router.back();
    },

  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/mixin.less";

.result-container {
  .loading {
    height: 100vh;
    width: 100%;
    text-align: center;
    line-height: 100vh;
    color: #808080;
  }
  .result {
    height: 100vh;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    .back-container {
      width: calc(100% - 15px);
      display: flex;
      align-items: center;
      margin-top: 20px;
      margin-left: 15px;
      font-size: 16px;
      line-height: 24px;
      color: #222328;
      .back-img {
        width: 24px;
        height: 24px;
        .bg-image("back");
        margin-right: 3px;
      }
    }
    .status-img {
      width: 80px;
      height: 101px;
      margin-top: 121px;
    }
    .success-img {
      .bg-image("success");
    }
    .error-img {
      .bg-image("error");
    }
    .status-desc {
      margin-top: 22px;
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #222328;
    }
    .status-sub-desc {
      margin-top: 8px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #a2a3ac;
    }
    .btn-back {
      margin-top: 28px;
    }
    .error-desc {
      width: calc(100% - 60px);
      margin: 40px 30px 0 30px;
      padding: 13px;
      background: #eef0f7;
      border-radius: 4px;
      border-radius: 4px;
      opacity: 0.7;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #82838b;
    }
  }
}
</style>
